<template>
    <el-dialog title="值域规则" width="750px" append-to-body :close-on-click-modal="false" :visible.sync="visible">
        <div class="m_b1 fontSize12">满足以下
            <el-select class="conditionSel" v-model="form.whereState" size="mini">
                <el-option label="所有" value="0"></el-option>
                <el-option label="任一" value="1"></el-option>
            </el-select>
            条件时
        </div>
        <el-button type="primary" @click="add()" size="small">添加条件</el-button>
        <el-form class="m_t1" size="mini" :model="form" :inline="true" ref="form" label-width="0px">
            <div v-for="(item, index) in form.metadataBasicDataRangeRuleDetailList" :key="index">
                <el-form-item :prop="`metadataBasicDataRangeRuleDetailList.${index}.basicDataDetailId`"
                              :rules="[{required: true, message: '元数据不能为空', trigger: 'change'}]">
                    <el-select v-model="item.basicDataDetailId" placeholder="请选择本模板下的元数据" filterable
                               @change="archivesChange(item)">
                        <el-option v-for="c in config" :key="c.id" :label="c.basicRename"
                                   :value="c.id" :disabled="c.disabled"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :prop="`metadataBasicDataRangeRuleDetailList.${index}.basicCondition`"
                              :rules="[{required: true, message: '条件不能为空', trigger: 'change'}]">
                    <el-select v-model="item.basicCondition" placeholder="请选择">
                        <el-option label="包含" value="包含"></el-option>
                        <el-option label="不包含" value="不包含"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :prop="`metadataBasicDataRangeRuleDetailList.${index}.metadataRangeIds`"
                              :rules="[{required: true, message: '筛选值不能为空', trigger: 'change'}]">
                    <el-select class="valItem" v-model="item.metadataRangeIds" placeholder="请选择筛选值" filterable
                               clearable multiple :multiple-limit="item.basicAssemblyId == '10' ? 1 : 0" @remove-tag="metadataRangeIdsChange($event, item)">
                        <el-option v-for="(v,i) in item.basicRangeList" :key="i" :disabled="v.rangDisabled"
                                   :label="v.basicRange"
                                   :value="v.metadataRangeId"></el-option>
                    </el-select>
                </el-form-item>
                <el-link class="m_t1" icon="el-icon-delete" type="danger" :underline="false"
                         @click="del(index)"></el-link>
            </div>
            <el-form-item label="值域显示：" prop="metadataBasicDataRangeRuleValueList" class="range" label-width="100px">
                <el-select class="w100i" v-model="form.metadataBasicDataRangeRuleValueList" size="mini" multiple
                           clearable @change="changeRangeDisplay">
                    <el-option v-for="(v,i) in rangeDisplayOpt" :key="i"
                               :label="v.basicRange"
                               :value="v.metadataRangeId"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="默认值：" prop="ruleDefaultValue" class="range" label-width="100px">
                <el-select class="w100i" v-model="form.ruleDefaultValue" size="mini" multiple
                           :multiple-limit="metadataInfo.basicAssemblyId == '6' || metadataInfo.basicAssemblyId == '7' ? 0 : 1"
                           clearable>
                    <el-option v-for="(v,i) in defaultValueOpt" :key="i"
                               :label="v.basicRange"
                               :value="v.metadataRangeId"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                visible: false,
                loading: false,
                method: '',
                row: {},
                form: {
                    basicDataDetailId: '',
                    basicDataId: '',
                    id: '',
                    whereState: '0',
                    metadataBasicDataRangeRuleDetailList: [],
                    metadataBasicDataRangeRuleValueList: [],
                    ruleDefaultValue: [],
                },
                rangeDisplayOpt: [],
                defaultValueOpt: [],
                metadataInfo: {},
                config: [],
                selArchives: [],
            }
        },
        methods: {
            init(item, method, metadataInfo) {
                this.method = method
                this.metadataInfo = metadataInfo
                this.form.whereState = '0'
                this.form.metadataBasicDataRangeRuleDetailList = []
                this.form.basicDataDetailId = metadataInfo.id
                this.form.basicDataId = metadataInfo.basicDataId
                if (item) {
                    this.row = item
                    this.form.id = item.id
                } else {
                    this.form.id = ''
                    this.row = {}
                }
                this.visible = true
                this.$nextTick(() => {
                    this.$refs.form.resetFields();
                    this.getSelectAllByBasicDataId()
                })
            },
            // 查询所有元数据
            getSelectAllByBasicDataId() {
                this.loading = true
                this.$axios(this.api.metadata.selectRangsByBasicDataId, {basicDataDetailId: this.metadataInfo.id, basicDataId: this.metadataInfo.basicDataId}).then(res => {
                    if (res.status) {
                        this.config = res.data.filter(v => v.id != this.metadataInfo.id)
                        if (this.method != 'add') {
                            this.row.metadataBasicDataRangeRuleDetailList.map((item, index) => {
                                let val = this.config.filter(v => v.id == item.basicDataDetailId)[0]
                                this.$set(item, 'basicRangeList', val.basicRangeList)
                                this.$set(item, 'basicAssemblyId', val.basicAssemblyId)
                            })
                        }
                        this.filterBasicData()
                        this.$nextTick(() => {
                            this.getRangeDisplay()
                        })
                    }
                    this.loading = false
                })
            },
            // 获取值域显示
            getRangeDisplay() {
                this.$axios(this.api.metadata.getById + '/' + this.metadataInfo.associationBasicId).then(res => {
                    if (res.status) {
                        this.rangeDisplayOpt = res.data.basicRangeList
                        this.defaultValueOpt = res.data.basicRangeList
                        this.$nextTick(() => {
                            if (this.method != 'add') {
                                let p = JSON.parse(JSON.stringify(this.row))
                                let arr2 = [], arr3 = []
                                this.row.metadataBasicDataRangeRuleDetailList.map((item, index) => {
                                    let arr = []
                                    item.basicRanges.map(v => {
                                        arr.push(v.metadataRangeId)
                                    })
                                    p.metadataBasicDataRangeRuleDetailList[index].metadataRangeIds = arr
                                })
                                this.row.metadataBasicDataRangeRuleValueList.map(item => {
                                    arr2.push(item.metadataRangeId)
                                })
                                this.row.ruleDefaultValue.map(item => {
                                    arr3.push(item.metadataRangeId)
                                })
                                p.metadataBasicDataRangeRuleValueList = arr2
                                p.ruleDefaultValue = arr3
                                this.form = this.recover(this.form, p)
                                if (p.metadataBasicDataRangeRuleValueList.length) {
                                    this.defaultValueOpt = this.rangeDisplayOpt.filter(item => p.metadataBasicDataRangeRuleValueList.some(id => item.metadataRangeId == id))
                                }
                                this.$nextTick(() => {
                                    this.filterBasicData()
                                })
                            }
                        })
                    }
                })
            },
            // 选择元数据
            archivesChange(item) {
                let val = this.config.filter(v => v.id == item.basicDataDetailId)[0]
                this.$set(item, 'basicAssemblyId', val.basicAssemblyId)
                this.$set(item, 'basicRangeList', val.basicRangeList)
                this.$set(item, 'basicCondition', '')
                this.$set(item, 'metadataRangeIds', [])
                this.filterBasicData()
            },
            // 选择值域
            metadataRangeIdsChange(id, item) {
                if(this.method == 'edit') {
                    let val = item.basicRangeList.filter(v => v.metadataRangeId == id)[0]
                    this.$set(val, 'rangDisabled', false)
                }
            },
            // 过滤元数据名称
            filterBasicData() {
                this.selArchives = []
                this.form.metadataBasicDataRangeRuleDetailList.map(v => {
                    if (v.basicDataDetailId) {
                        this.selArchives.push(v.basicDataDetailId)
                    }
                })
                this.config.map(item => {
                    this.$set(item, 'disabled', false)
                })
                this.$nextTick(() => {
                    for (let id of this.selArchives) {
                        let itemJson = this.config.find((item) => {
                            return item.id === id
                        });
                        this.$set(itemJson, 'disabled', true)
                    }
                })
            },
            // 删除筛选条件
            del(index) {
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.form.metadataBasicDataRangeRuleDetailList.splice(index, 1);
                    this.filterBasicData()
                })
            },
            // 添加条件
            add() {
                this.form.metadataBasicDataRangeRuleDetailList.push({
                    basicDataDetailId: '',
                    basicCondition: '',
                    metadataRangeIds: [],
                    basicRangeList: [],
                })
            },
            // 选择值域显示
            changeRangeDisplay(val) {
                if(val.length) {
                    this.defaultValueOpt = this.rangeDisplayOpt.filter(item => val.some(id => item.metadataRangeId == id))
                    this.form.ruleDefaultValue = this.form.ruleDefaultValue.filter(item => val.some(id => item == id))
                } else {
                    this.defaultValueOpt = this.rangeDisplayOpt
                    this.form.ruleDefaultValue = []
                }
            },
            // 表单提交
            doSubmit() {
                if(!this.form.metadataBasicDataRangeRuleDetailList.length && !this.form.metadataBasicDataRangeRuleValueList.length && !this.form.ruleDefaultValue.length) {
                    this.$message.warning('请添加值域规则')
                    return
                }
                if(!this.metadataInfo.condition && !this.form.metadataBasicDataRangeRuleDetailList.length) {
                    this.$message.warning('请添加条件')
                    return
                }
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        if(this.form.metadataBasicDataRangeRuleDetailList.length && !this.form.metadataBasicDataRangeRuleValueList.length && !this.form.ruleDefaultValue.length) {
                            this.$message.warning('请选择值域显示或者默认值')
                            return
                        }
                        this.$axios(this.api.metadata.rangeRuleSave, this.form, 'post').then(data => {
                            if (data.status) {
                                this.$message.success('保存成功')
                                this.visible = false
                                this.$emit('refreshDataList')
                            } else {
                                this.$message.error(data.msg)
                            }
                            this.loading = false
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .condition {
        font-size: 12px;
    }

    .conditionSel {
        width: 80px !important;
        margin: 0 5px;
    }

    .range {
        width: 100% !important;
    }

    .range >>> .el-form-item__content {
        width: 76% !important;
    }


</style>
